export const STATSIG_CLIENT_KEY =
  process.env.REACT_APP_STATSIG_CLIENT_KEY ?? "";
export const STATSIG_ENV_TIER = process.env.REACT_APP_STATSIG_ENV_TIER ?? "";

export const PAY_BEFORE_SETUP_CAMPAIGN_GATE = "pay_before_setup_campaign_gate";
export const SELF_SERVE_CAMPAIGN_CREATION_AND_ACTIVATION_FLOW_GATE =
  "self-serve_campaign_creation_and_activation_flow";

export const PAY_BEFORE_SETUP_BLOCKED_ROUTES = [
  "/collabs",
  "/campaigns",
  "/applications",
  "/report",
  "/messenger",
  "/settings",
] as const;
